export default __webpack_public_path__ + "static/media/financial_help_banner.0aacefef.png";